// extracted by mini-css-extract-plugin
module.exports = {"show-story":"show-story_show-story__Z3dI3","show-story__title":"show-story_show-story__title__eMptK"};